import logogradient from "./assets/logo.svg";
import logo from "./assets/logo2.svg";
import profile from "./assets/profile.png";
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import sass from "./assets/techstack/sass.png";
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
import redux from "./assets/techstack/redux.png";
import tailwind from "./assets/techstack/tailwind.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
import npm from "./assets/techstack/npm.png";
import postman from "./assets/techstack/postman.png";
import MERN from "./assets/techstack/MERN.png";
import python from "./assets/techstack/python.png";
import aws from "./assets/techstack/aws.png";
import express from "./assets/techstack/express.png";
import firebase from "./assets/techstack/firebase.png";
import heroku from "./assets/techstack/heroku.png";
import flask from "./assets/techstack/flask.png";
import mysql from "./assets/techstack/mysql.png";
import node from "./assets/techstack/node.png";
import photoshop from "./assets/techstack/photoshop.png";
import premier from "./assets/techstack/premier.png";
import mystro from "./assets/projects/mystro.png";
import dreamBooker from "./assets/projects/dreamBooker.png";
import cubeseed from "./assets/projects/cubeseed.png";
import next from "./assets/techstack/next.png";
import chat from "./assets/projects/chat-project.png";
import insights from "./assets/projects/insights-project.png";
import quest from "./assets/projects/quest-project.png";
import wendys from "./assets/Wendys.png";
import nolaPlayers from "./assets/NolaPlayers.png";

export const logos = {
  logogradient: logogradient,
  logo: logo,
};

export const personalDetails = {
  name: "Billy Franklin",
  img: profile,
  about: `Fullstack engineer with production experience across TypeScript/React frontends, Python microservices, REST APIs, and cloud infrastructure on GCP and AWS. Currently the sole frontend developer on an enterprise dashboard serving all US Wendy’s locations, architected from scratch with no prior guidelines, full accessibility compliance, and unit test coverage. Previously led engineering at an AI healthtech startup through a full team transition, owning product, infrastructure, and delivery end to end. Works fluidly with AI coding tools including Claude Code and Cursor; multiple production features have been built and shipped using this approach.`
};

export const socialMediaUrl = {
  linkedin: "https://www.linkedin.com/in/billyfranklin/",
  github: "https://github.com/BillyFranklinNola",
  portfolio: "https://bf-portfolio.com",
};

export const workDetails = [
  {
    Position: "Software Engineer",
    Company: "Wendy's Corporate",
    Location: "Remote",
    Type: "Full Time",
    Duration: "Nov 2025 – Present",
  },
  {
    Position: "SWE Team Lead",
    Company: "CuraJoy (AI Healthtech Nonprofit)",
    Location: "Remote",
    Type: "Full Time",
    Duration: "Oct 2024 – Sep 2025",
  },
  {
    Position: "Full Stack Developer",
    Company: "CuraJoy",
    Location: "Remote",
    Type: "Full Time",
    Duration: "Jan 2024 – Oct 2024",
  },
  {
    Position: "Frontend Developer",
    Company: "Cubeseed",
    Location: "Remote",
    Type: "Contract",
    Duration: "Jan 2024 – Oct 2024",
  },
  {
    Position: "Freelance Fullstack Developer",
    Company: "Nola Live Productions LLC",
    Location: "New Orleans, LA",
    Type: "Part Time",
    Duration: "2020 – 2023",
  },
];

export const certDetails = [
  {
    name: "AWS Essentials Training",
  },
];

export const eduDetails = [
  {
    Position: "Fullstack Development Certificate",
    Company: "Coding Dojo",
    Location: "Online",
    Type: "Full Time",
    Duration: "Python, JavaScript/MERN stack, and web development",
  },
  {
    Position: "Bachelor of Arts – Jazz Performance",
    Company: "University of New Orleans",
    Location: "New Orleans, LA",
    Type: "Full Time",
    Duration: "Graduated",
  },
];

export const techStackDetails = {
  html: html,
  css: css,
  js: js,
  next: next,
  python: python,
  react: react,
  mern: MERN,
  redux: redux,
  sass: sass,
  tailwind: tailwind,
  bootstrap: bootstrap,
  vscode: vscode,
  postman: postman,
  npm: npm,
  git: git,
  github: github,
  aws: aws,
  express: express,
  firebase: firebase,
  heroku: heroku,
  flask: flask,
  mysql: mysql,
  node: node,
  photoshop: photoshop,
  premier: premier,
};

export const projectDetails = [
  {
    title: "Wendy's Cost Analysis Dashboard",
    image: wendys,
    description:
      "Enterprise Cost Analysis dashboard serving all US Wendy's franchise locations. Sole frontend developer; architected from scratch with Next.js and TypeScript with no existing guidelines or prior codebase.",
    features: [
      "Data visualization interfaces for financial analysis across nationwide restaurant operations",
      "Full accessibility compliance (WCAG) and unit test coverage from the ground up",
      "Defined frontend API requirements and collaborated with data engineering on REST contracts",
      "Code Review and Apigee integration for preview environment deployment",
    ],
    previewLink: null,
  },
  {
    title: "Data Visualization Dashboard",
    image: insights,
    description:
      "A data visualization dashboard that dynamically returns data trends and insights based on user check-ins .",
    features: [
      "Customizable line graphs to track body, mood, behavior data",
      "Dynamic bubble chart to track mood intensity and frequency",
      "3D avatar with heatmap to display body check-in data",
      "Intuitive filtering and sorting options for data analysis",
    ],  
    previewLink: "https://my.curajoy.org/insights",
  },
  {
    title: "Dynamic LLM Chat Application",
    image: chat,
    description:
      "A dynamic chat application that integrates with LLMs to provide personalized responses based on user input.",
    features: [
      "Websocket-based real-time chat functionality",
      "LLM integration with user context and RAG for personalized responses",
      "Harm reduction and PII redaction functionality",
      "Chatbot coach walks the user through clinical assessments and then scores them",
      "Dialogflow inttegration for intent recognition and sentiment analysis",
      "Live clinician handoff for urgent cases"
    ],
    previewLink: "https://my.curajoy.org/my-profile",
  },
  {
    title: "Quest (treatment plan) Dashboard",
    image: quest,
    description:
      "A dashboard that provides personalized activities based on user info and quest settings.",
    features: [
      "AI recommendations personalized activities for user",
      "Dynamic tracking calendar to monitor progress",
      "AI created custom images for quest",
      "User settings to customize goals and user frequency",
    ],
    previewLink: "https://my.curajoy.org/quests/quests",
  },
  {
    title: "Cubeseed",
    image: cubeseed,
    description:
      "A contract-driven marketplace that facilitates seamless agro-trade and connects small farmers to markets, finance, quality inputs and services",
    features: [
      "React, Next.js, Typescript, Tailwind CSS",
    ],
    previewLink: "https://cubeseed.com.ng/",
  },
  {
    title: "The New Orleans Players — Wedding & Event Band Platform",
    image: nolaPlayers,
    description:
      "Full-stack web app for a New Orleans wedding and event band, serving clients, musicians, and admins. Built with Next.js 16, React 19, TypeScript, Tailwind CSS, and Supabase (PostgreSQL, Auth).",
    features: [
      "Public site: Dynamic quote calculator, media gallery (audio/video/images), Instagram feed, reviews, FAQ, contact form with Formspree and Nodemailer",
      "Admin dashboard: Gig and musician management, contract lifecycle (draft → send → client submit → approve), PDF generation with PDFKit, email history, review request flow",
      "Musician portal: Gig assignments with accept/decline via tokenized links, setlist and song management, calendar sync (Google/Apple/Outlook)",
      "Client portal: Token-based contract viewing and signing, gig acceptance flow; deployed on Vercel with Vercel Analytics",
    ],
    previewLink: "https://nolaplayers.com",
  },
  {
    title: "Mystro Musician",
    image: mystro,
    description: `A Full-Stack MERN application for professional Bandleaders and Musicians`,
    features: [
      "User authentication and profile management",
      "Real-time gig management and scheduling",
      "Weather API integration for gig planning",
      "Google Maps API integration for location-based services",
      "Customizable event scheduling and management"
    ],
    previewLink: "https://mystro-demo-0b5d2a04899c.herokuapp.com/",
  },
  {
    title: "Dream Booker",
    image: dreamBooker,
    description: `A mobile booking app created in the style of Hotels.com`,
    features: [
      "React Native, Redux, Firebase",
    ],
    previewLink: "https://youtu.be/s3KbothCPmc",
  },
];

export const contactDetails = {
  email: "atmanroots@gmail.com",
  phone: "+1 504 495 8924",
};
